module.exports = __webpack_public_path__ + "img/Card_club_2.4cf77742.svg";